import { create } from "zustand";

interface SidebarState {
  width: number;
  collapsed: boolean;
  setWidth: (w: number) => void;
  toggle: () => void;
  open: boolean;
  toggleOpen: () => void;
}

const MIN_WIDTH = 56;
const MAX_WIDTH = 320;

export const useSidebarStore = create<SidebarState>((set) => ({
  width: 256,
  collapsed: false,

  open: false,
  toggleOpen: () => set((s) => ({ open: !s.open })),

  setWidth: (w) =>
    set({
      width: Math.min(MAX_WIDTH, Math.max(MIN_WIDTH, w)),
      collapsed: w <= MIN_WIDTH + 8
    }),

  toggle: () =>
    set((s) => ({
      collapsed: !s.collapsed,
      width: s.collapsed ? 256 : MIN_WIDTH
    }))
}));